import { As } from '@chakra-ui/react';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';

export const footerLinks = [
  {
    label: 'Kontak Kami',
    url: 'https://www.sukandaonelink.com/hubungi-kami',
    isExternal: true,
  },
  {
    label: 'Bantuan',
    url: 'https://www.sukandaonelink.com/#faq',
    isExternal: true,
  },
  {
    label: 'Kebijakan Privasi',
    url: 'https://www.sukandaonelink.com/kebijakan-privasi',
    isExternal: true,
  },
  {
    label: 'Ketentuan Cookies',
    url: 'https://www.sukandaonelink.com/syarat&ketentuan',
    isExternal: true,
  },
];

export interface socialMediasInterface {
  label: string;
  icon: As;
  url: string;
}
export const socialMedias: socialMediasInterface[] = [
  {
    label: 'Facebook',
    icon: FacebookOutlinedIcon,
    url: 'https://id-id.facebook.com/sukandadjayaofficial',
  },
  {
    label: 'Instagram',
    icon: InstagramIcon,
    url: 'https://www.instagram.com/sukandadjaya',
  },
  {
    label: 'Twitter',
    icon: TwitterIcon,
    url: 'https://twitter.com/ptsukandadjaya',
  },
];
